(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apm-shopfront"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-apm-carousel]:not([data-ready])').forEach(root => {
      const slides = Array.from(root.querySelectorAll('.apm-carousel-slide'));
      if (!slides.length) { root.hidden = true; return; }
      const track = root.querySelector('.apm-carousel-track');
      const controls = root.querySelector('.apm-carousel-controls');
      const pause = root.querySelector('.apm-carousel-pause');
      const positions = Array.from(root.querySelectorAll('[data-slide]'));
      const status = root.querySelector('.apm-carousel-status');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, stopped = motion.matches, hovering = false, timer = null, start = null;
      const schedule = () => {
        clearTimeout(timer);
        const focused = root.contains(document.activeElement) && document.activeElement !== pause;
        if (!stopped && !hovering && !focused && !document.hidden && slides.length > 1) timer = setTimeout(() => show(index + 1), 7000);
      };
      const sync = () => {
        pause.textContent = stopped ? root.dataset.playLabel : root.dataset.pauseLabel;
        status.setAttribute('aria-live', stopped ? 'polite' : 'off');
        schedule();
      };
      const stop = () => { stopped = true; sync(); };
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, i) => { slide.inert = i !== index; slide.setAttribute('aria-hidden', String(i !== index)); slide.setAttribute('aria-label', `${i + 1} / ${slides.length}`); });
        positions.forEach((button, i) => { if (i === index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
        root.querySelector('[data-current]').textContent = String(index + 1);
        schedule();
      };
      root.dataset.ready = 'true'; controls.hidden = slides.length < 2;
      root.querySelector('.apm-carousel-prev').addEventListener('click', () => { stop(); show(index - 1); });
      root.querySelector('.apm-carousel-next').addEventListener('click', () => { stop(); show(index + 1); });
      positions.forEach(button => button.addEventListener('click', () => { stop(); show(Number(button.dataset.slide)); }));
      pause.addEventListener('click', () => { stopped = !stopped; sync(); });
      root.addEventListener('focusin', event => { if (event.target !== pause) stop(); });
      root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } });
      root.addEventListener('pointerleave', () => { hovering = false; schedule(); });
      root.addEventListener('pointerdown', event => { if (event.target !== pause) stop(); if (event.pointerType !== 'mouse') start = {x:event.clientX,y:event.clientY}; });
      root.addEventListener('pointerup', event => { if (!start) return; const dx=event.clientX-start.x,dy=event.clientY-start.y; start=null; if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.25) show(index+(dx<0?1:-1)); });
      root.addEventListener('pointercancel', () => { start=null; });
      root.addEventListener('keydown', event => { if (event.target === pause) return; if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();stop();show(index+(event.key==='ArrowRight'?1:-1));} });
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', () => { if(motion.matches) stop(); });
      show(0); sync();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
